import type { Decimal } from "decimal.js";

export interface DecimalConstraints {
  minValue?: number;
  maxValue?: number;
  maxDecimals?: number;
}

export function validateDecimalConstraints(
  decimalValue: Decimal | null,
  constraints: DecimalConstraints,
): string | null {
  if (decimalValue == null) {
    return null;
  }

  if (constraints.minValue != undefined && decimalValue.lessThan(constraints.minValue)) {
    return `The minimum value is ${constraints.minValue}.`;
  }

  if (constraints.maxValue != undefined && decimalValue.greaterThan(constraints.maxValue)) {
    return `The maximum value is ${constraints.maxValue}.`;
  }

  if (constraints.maxDecimals == undefined) {
    return null;
  }

  const decimalPlaces = decimalValue.decimalPlaces();

  if (constraints.maxDecimals === 0 && decimalPlaces > 0) {
    return "Must be an integer.";
  }

  if (decimalPlaces > constraints.maxDecimals) {
    return `The number may have at most ${constraints.maxDecimals} digits after the decimal.`;
  }

  return null;
}
